import './styles.scss'

export default function About(props) {

  return (
    <div className='Mobile'>
      This experience is optimized for desktop viewing. For a full feature rich
      experience view this site on a device with a larger screen.
    </div>
  )
}
